const drill_pt = require('./drill.json')
export default drill_pt